import { DesignChannelToTextChannel, DesktopWizardProps } from '../../Types'
import { DesktopWizard } from '../../DesktopWizard/DesktopWizard'
import { RefineCaption } from '../Steps/RefineCaption/RefineCaption'
import { PostType } from '../Steps/PostType/PostType'
import { useMemo, useState } from 'react'
import { ImageSelection } from '../Steps/ImageSelection/ImageSelection'
import { FlowCSchema, FlowCSchemaWithImage, FlowCSchemaVisual } from 'components/Wizards/schemas/Desktop/FlowC'
import { DesignChannel } from 'components/NewFileModal/Types'
import { PurposeAndGoals } from '../Steps/PurposeAndGoals/PurposeAndGoals'
import { TemplateAndCaption } from '../Steps/TemplateAndCaption/TemplateAndCaption'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { TemplateSchema } from 'components/Wizards/schemas/Desktop/Common'
import { StepSchema } from 'components/Wizards/schemas/Types'
import { ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'

export type PostTypes = 'text' | 'visual'

export const FlowC = observer((props: DesktopWizardProps) => {
  const { initialValues } = props

  const startWithTemplate = initialValues?.startWithTemplate
  const source_visual_element_id = initialValues?.source_visual_element_id
  const [selectedType, setSelectedType] = useState<PostTypes>(startWithTemplate ? 'visual' : 'text')
  const [showImagesStep, setShowImagesStep] = useState(false)
  const { visualElements } = useRootStore()

  const initialTemplate = useMemo(
    () =>
      source_visual_element_id && startWithTemplate ? visualElements.getElement(source_visual_element_id) : undefined,
    [], // eslint-disable-line react-hooks/exhaustive-deps
  )

  if (initialValues?.startFromBrandKit) {
    const title = props.schema.meta.title
    const articleWithA = ['a', 'e', 'i', 'o', 'u'].includes(title[0]) ? `an ${title}` : `a ${title}`

    return (
      <DesktopWizard
        {...props}
        schema={{
          ...props.schema,
          steps: [
            TemplateSchema.meta({
              header: `We turned your website from your Brand Kit into ${articleWithA} for you!`,
              title: 'Review',
              hideStepHeader: true,
            }) as StepSchema,
          ],
        }}
      >
        <TemplateAndCaption />
      </DesktopWizard>
    )
  }

  const hidePostTypeStep = !!initialTemplate
  const textChannel = DesignChannelToTextChannel[props.schema.meta.channel as unknown as DesignChannel]

  let schema = props.schema
  let generationType = textChannel && selectedType === 'text' ? textChannel : schema.meta.channel
  let meta = { ...schema.meta, channel: generationType }

  if (textChannel && selectedType === 'text') {
    const FlowCSchemaComponent = showImagesStep ? FlowCSchemaWithImage : FlowCSchema

    schema = {
      ...FlowCSchemaComponent({ generationType }),
      meta,
    }
  }

  if (selectedType === 'visual') {
    schema = {
      ...FlowCSchemaVisual({ generationType, hidePostTypeStep }),
      meta,
    }

    return (
      <DesktopWizard {...props} schema={schema}>
        {!hidePostTypeStep && (
          <PostType
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            onMount={() => setShowImagesStep(false)}
          />
        )}
        <PurposeAndGoals />
        <TemplateAndCaption submitLabel={'Select Design'} />
      </DesktopWizard>
    )
  }

  return (
    <DesktopWizard {...props} schema={schema} isGeneratingDoc>
      <PostType
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        onMount={() => setShowImagesStep(false)}
      />
      <RefineCaption onShowImages={setShowImagesStep} />
      {showImagesStep && <ImageSelection confirmImage confirmVideo accept={ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES} />}
    </DesktopWizard>
  )
})
